import { render, staticRenderFns } from "./WidthList.vue?vue&type=template&id=4a0bd305&"
import script from "./WidthList.vue?vue&type=script&lang=js&"
export * from "./WidthList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports